import { DISABLE, ENABLE, LOAD, RESET } from 'model/palIfpCredential';
import {
  disable as disableCredential,
  enable as enableCredential,
  resetRequest as resetCredentialPassword,
  status as getCredentialStatus,
} from 'sdk/palIfpCredential';
import { takeLatest } from 'redux-saga/effects';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeLatest(
    LOAD.ACTION,
    callAction({
      api: getCredentialStatus,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeLatest(
    DISABLE.ACTION,
    callAction({
      api: disableCredential,
      dataName: ORM,
      type: DISABLE,
    })
  );

  yield takeLatest(
    ENABLE.ACTION,
    callAction({
      api: enableCredential,
      dataName: ORM,
      type: ENABLE,
    })
  );

  yield takeLatest(
    RESET.ACTION,
    callAction({
      api: resetCredentialPassword,
      dataName: ORM,
      type: RESET,
    })
  );
}
